export const TEST_ID = {
  uploadProgressSnackbar: 'uploadProgressSnackbar',
  cancelButton: 'cancelButton',
};
